<div class="login-page">
  <div class="login-shell">
    <section class="login-brand-panel">
      <div class="brand-mark">
        <img
          class="brand-mark__logo"
          src="assets/img/logo.png"
          alt="RB Clínica Dental"
        />
      </div>
      <p class="brand-description">Tu espacio de gestión clínica.</p>
    </section>

    <section class="login-card">
      @if (!recoveryMode) {
      <div class="login-card__header">
        <h2>Inicia sesión</h2>
        <p class="subtitle">Introduce tus credenciales para continuar.</p>
      </div>

      <form class="login-form" (ngSubmit)="submit()">
        <div class="form-group">
          <label for="username">Usuario o email</label>
          <div class="input-shell">
            <span class="input-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path
                  d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm0 2c-4.418 0-8 2.239-8 5v1h16v-1c0-2.761-3.582-5-8-5Z"
                />
              </svg>
            </span>
            <input
              id="username"
              name="username"
              type="text"
              [(ngModel)]="username"
              autocomplete="username"
              maxlength="254"
              autocapitalize="none"
              autocorrect="off"
              spellcheck="false"
              required
            />
          </div>
        </div>

        <div class="form-group">
          <label for="password">Contraseña</label>
          <div class="input-shell input-shell--password">
            <span class="input-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path
                  d="M17 10V8a5 5 0 0 0-10 0v2H5v10h14V10Zm-8 0V8a3 3 0 0 1 6 0v2Zm3 7a2 2 0 0 1-1-3.732V12h2v1.268A2 2 0 0 1 12 17Z"
                />
              </svg>
            </span>
            <input
              id="password"
              name="password"
              [type]="showPassword ? 'text' : 'password'"
              [(ngModel)]="password"
              autocomplete="current-password"
              maxlength="128"
              required
            />
            <button
              class="password-visibility"
              type="button"
              [attr.aria-label]="
                showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'
              "
              [attr.aria-pressed]="showPassword"
              (click)="togglePasswordVisibility()"
            >
              <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
                @if (showPassword) {
                <path
                  d="M3 3l18 18M10.6 10.7a2 2 0 0 0 2.7 2.7M9.9 4.3A10.7 10.7 0 0 1 12 4c5.5 0 9 6 9 6a18 18 0 0 1-2.2 2.9M6.6 6.6C4.3 8.2 3 10 3 10s3.5 6 9 6a9.8 9.8 0 0 0 3.4-.6"
                />
                } @else {
                <path
                  d="M3 12s3.5-6 9-6 9 6 9 6-3.5 6-9 6-9-6-9-6Zm9 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                />
                }
              </svg>
            </button>
          </div>
        </div>

        <button class="recovery-link" type="button" (click)="openRecovery()">
          ¿Has olvidado tu contraseña?
        </button>

        <button class="submit-button" type="submit" [disabled]="loading">
          @if (loading) { Entrando... } @if (!loading) { Entrar en la plataforma
          }
        </button>
      </form>
      } @else if (!recoverySent) {
      <div class="login-card__header">
        <h2>Restablece tu contraseña</h2>
        <p class="subtitle">
          Indica tu usuario o email y te enviaremos un enlace para crear una
          contraseña nueva.
        </p>
      </div>

      <form class="login-form" (ngSubmit)="submitRecovery()">
        <div class="form-group">
          <label for="recovery-identifier">Usuario o email</label>
          <div class="input-shell">
            <span class="input-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path
                  d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm0 2c-4.418 0-8 2.239-8 5v1h16v-1c0-2.761-3.582-5-8-5Z"
                />
              </svg>
            </span>
            <input
              id="recovery-identifier"
              name="recoveryIdentifier"
              type="text"
              [(ngModel)]="recoveryIdentifier"
              autocomplete="email"
              maxlength="254"
              autocapitalize="none"
              autocorrect="off"
              spellcheck="false"
              required
            />
          </div>
        </div>

        <button
          class="submit-button"
          type="submit"
          [disabled]="recoveryLoading"
        >
          {{
            recoveryLoading
              ? "Enviando solicitud..."
              : "Solicitar restablecimiento"
          }}
        </button>
        <button
          class="secondary-button"
          type="button"
          (click)="closeRecovery()"
        >
          Volver al inicio de sesión
        </button>
      </form>
      } @else {
      <div class="recovery-confirmation" role="status">
        <span class="recovery-confirmation__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <path d="m5 12 4 4L19 6" />
          </svg>
        </span>
        <h2>Revisa tu correo</h2>
        <p class="subtitle">
          Si la cuenta existe, está activa y tiene un email asociado, recibirás
          un enlace para crear una nueva contraseña. El enlace caduca en 30
          minutos.
        </p>
        <button class="submit-button" type="button" (click)="closeRecovery()">
          Volver al inicio de sesión
        </button>
      </div>
      }

      <div class="login-card__footer">
        <span>Acceso restringido a personal autorizado</span>
      </div>
    </section>
  </div>
</div>
